import { buildAxonItem, pushAxonEvent } from '@/utils/axonTrack'

export function useAxonPurchase() {
  function reportPurchase(
    productId: string | number,
    contentId: string | number | undefined,
    itemName: 'Coins Package' | 'Membership',
    price: string | number,
    transactionId: string,
  ) {
    pushAxonEvent('purchase', {
      currency: 'USD',
      value: Number(price),
      transaction_id: transactionId,
      dedupe_id: transactionId,
      items: [buildAxonItem(productId, contentId, itemName, price)],
    })
  }

  return { reportPurchase }
}
